import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles<Theme>(theme => ({
    container: {
        backgroundColor: theme.palette.primary.dark,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            paddingLeft: '1rem',
            paddingRight: '1rem',
            paddingTop: '2rem',
            paddingBottom: '0.5rem',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            paddingLeft: '2rem',
            paddingRight: '2rem',
            paddingTop: '1rem',
            paddingBottom: 0,
        },
        [theme.breakpoints.up('lg')]: {
            marginBottom: 15,
        },
    },
    logoAndTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '1rem',
    },
    pageTitle: {
        color: 'white',
        fontWeight: 600,
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            fontSize: '1.4rem',
            marginLeft: '1.5rem',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: '1.1rem',
            marginLeft: '1rem',
        },
    },
    logo: {
        width: '21px',
        height: '21px',
    },
    eventInfoButton: {
        color: 'white',
        borderBottom: `4px solid ${theme.palette.primary.main}`,
        borderRadius: 0,
        textTransform: 'none',
        fontSize: '18px',
        fontWeight: 400,
        flexBasis: '50%',
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    cancelOrPublishButton: {
        textTransform: 'none',
        color: 'white',
        borderRadius: '50px',
        fontSize: '0.9rem',
        padding: '0.25rem 1rem',
        margin: '0 0.25rem',
        fontWeight: 400,
        '&:hover': {
            transition: 'all .2s ease-in-out',
            transform: 'scale(1.05)',
        },
    },
    cancelButton: {
        backgroundColor: theme.palette.secondary.light,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
        },
    },
    publishButton: {
        backgroundColor: theme.palette.success.dark,
        '&:hover': {
            backgroundColor: theme.palette.success.dark,
        },
    },
}));
